import axios from "axios";

export const normalizeRequestParams = (params) => {
  if (params?.args !== null && typeof params?.args === "object") {
    return {
      ...params,
      args: JSON.stringify(params.args),
    };
  }

  return params;
};

export const doGet = async (endPoint, params, config) => {
  try {
    const response = await axios.get(endPoint, config ? config : { params: params });
    return response?.data;
  } catch (error) {
    if (error.response !== undefined && error.response.status.toString().startsWith("4")) {
      throw error;
    } else if (error?.name === "TokenError") {
      throw new Error(error?.message);
    } else {
      console.log(error);
      throw error;
    }
  }
};

export const doDelete = async (endPoint, isAlert, params) => {
  if (!isAlert) {
    try {
      return await axios.delete(endPoint, {
        withCredentials: true,
        params: params,
      });
    } catch (error) {
      if (error.response !== undefined && error.response?.status.toString().startsWith("404")) {
        console.log("404 error");
      } else if (error?.status === "TokenError") {
        throw new Error(error?.message);
      } else {
        console.log(error);
      }
    }
  } else {
    return await axios.delete(endPoint, {
      params: params,
    });
  }
};

export const doPost = async (endPoint, postObj, isAlert, params) => {
  if (!isAlert) {
    try {
      return await axios.post(endPoint, postObj, {
        withCredentials: true,
        params: normalizeRequestParams(params),
      });
    } catch (error) {
      if (error.response !== undefined && error.response?.status.toString().startsWith("404")) {
        console.log("404 error");
      } else if (error?.status === "TokenError") {
        throw new Error(error?.message);
      } else {
        console.log(error);
      }
    }
  } else {
    return await axios.post(endPoint, postObj, {
      params: normalizeRequestParams(params),
    });
  }
};
